import React from 'react'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'
import Button from 'components/atoms/Button'

import config from 'config'

const { assets_url: assetsUrl } = config

const NewAptitudeBanner = () => (
  <div className="new-aptitude-banner">
    <Container>
      <div className="new-aptitude-banner__content">
        <Row>
          <Col md="6">
            <Typography
              component="h2"
              variant="big"
              className="new-aptitude-banner__title"
            >
              Ingin tahu!
            </Typography>
            <div className="new-aptitude-banner__desc">
              <Typography component="p" variant="headline" className="new-aptitude-banner__desc-txt">Apakah kira-kira kamu cocok dengan jurusan atau karier ini atau tidak?</Typography>
              <Button variant="orange" href="/aptitude_test" target="_blank" rel="noopener">Ikuti Test Sekarang!</Button>
            </div>
          </Col>
          <Col md="6" className="no-mobile">
            <div className="new-aptitude-banner__phone">
              <img src={`${assetsUrl}/assets/img/major_detail/phone.png`} alt="Aptitude Test Mobile Phone"/>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
    <style jsx>
      {`
        @import url('https://fonts.googleapis.com/css?family=Pacifico');
        .new-aptitude-banner {
          padding-top: 48px;
          padding-bottom: 48px;
          background-color: #fff;
          background-image: url(${assetsUrl}/assets/img/light-grey-accent.svg), url(${assetsUrl}/assets/img/major_detail/triple-rect-accent.svg);
          background-position: center left, center right;
          background-repeat: no-repeat, no-repeat;
          :global(&__title) { 
            color: #0c2846;
            font-family: 'Pacifico', cursive;
            transform: rotate(-10deg);
            margin-top: -32px !important;
            @media screen and (max-width: 767px) {
              text-align: center;
              margin-top: -24px !important;
            }
          }
          &__content {
            background-image: linear-gradient(98deg, #00beff, #0fc3c4);
            border-radius: 8px;
            padding-left: 64px;
            height: 252px;
            @media screen and (max-width: 767px) {
              padding-left: 24px;
              padding-right: 24px;
            }
          }
          &__phone {
            background-image: url(${assetsUrl}/assets/img/major_detail/rectangle-element-aptitude.svg);
            background-repeat: no-repeat;
            background-position: top 40% right;
            margin-top: -32px;
            margin-left: 32px;
          }
          &__desc {
            margin-top: 64px;
            @media screen and (max-width: 767px) {
              margin-top: 32px;
            }
          }
          :global(&__desc-txt) {
            margin-top: 16px !important;
            margin-bottom: 16px !important;
            color: #fff;
          }
          :global(.no-mobile) {
            @media screen and (max-width: 767px) {
              display: none;
            }
          }
        }
      `}
    </style>
  </div>
)

export default NewAptitudeBanner
